<div class="theme-wrapper {{ portalConfig?.theme }}">
  <ng-content select="[searchAndHerobanner]"> </ng-content>
  <ng-content select="[applicantTypeToggle]"> </ng-content>
  <ng-content select="[featuredServices]"> </ng-content>
  <ng-content select="[categoryServices]"> </ng-content>
</div>
